import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useDeleteEvacuationPlan } from "./useEvacuationData";

interface UseDeleteEvacuationPlanWithConfirmResult {
  handleDelete: (id: string | number) => void;
  isDeleting: boolean;
}

export const useDeleteEvacuationPlanWithConfirm = (
  redirectPath: string = "/admin/evacuation"
): UseDeleteEvacuationPlanWithConfirmResult => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { mutate: deletePlan, isLoading: isDeleting } = useDeleteEvacuationPlan();

  const handleDelete = useCallback(
    (id: string | number) => {
      if (window.confirm("Är du säker på att du vill ta bort denna checklista?")) {
        const numericId = typeof id === "string" ? parseInt(id, 10) : id;
        deletePlan(numericId, {
          onSuccess: () => {
            enqueueSnackbar("Checklista borttagen.", { variant: "success" });
            navigate(redirectPath);
          },
          onError: () => {
            enqueueSnackbar("Kunde inte ta bort checklistan.", {
              variant: "error",
            });
          },
        });
      }
    },
    [deletePlan, navigate, redirectPath, enqueueSnackbar]
  );

  return { handleDelete, isDeleting };
};
